import API from '../../../helpers/api';

import CLIENT from '../actionTypes';

import { AppDispatch, GetState } from '../../../types/app';

export const sendCode =
  (email: string, passwordType: string) =>
  async (dispatch: AppDispatch, getState: GetState) => {
    dispatch({ type: CLIENT.RECOVERY_PASSWORD.SEND_CODE.REQUESTING });

    const {
      intl: { locale: lang },
    } = getState();

    try {
      const { sessionId } = await API.callGraphQL<{ sessionId: string }>(
        `
      mutation($Email: String!, $Type: PasswordType!, $Lang: Lang!) {
        sessionId: clientRecoveryPasswordSendCode(Email: $Email, Type: $Type, Lang: $Lang)
      }
    `,
        {
          Email: email,
          Type: passwordType,
          Lang: lang,
        }
      );

      return dispatch({
        type: CLIENT.RECOVERY_PASSWORD.SEND_CODE.SUCCESS,
        sessionId,
        email,
        passwordType,
      });
    } catch (err) {
      return dispatch({
        type: CLIENT.RECOVERY_PASSWORD.SEND_CODE.FAILURE,
        err: err.message,
      });
    }
  };

export const changePassword =
  (code: string, password: string) =>
  async (dispatch: AppDispatch, getState: GetState) => {
    dispatch({ type: CLIENT.RECOVERY_PASSWORD.CHANGE_PASSWORD.REQUESTING });

    const {
      ClientRecoveryPassword: { sessionId },
    } = getState();

    try {
      await API.callGraphQL(
        `
      mutation($SessionId: String!, $Code: String!, $Password: String!) {
        result: clientRecoveryPasswordChange(SessionId: $SessionId, Code: $Code, Password: $Password)
      }
    `,
        {
          SessionId: sessionId,
          Code: String(code),
          Password: password,
        }
      );

      return dispatch({
        type: CLIENT.RECOVERY_PASSWORD.CHANGE_PASSWORD.SUCCESS,
      });
    } catch (err) {
      return dispatch({
        type: CLIENT.RECOVERY_PASSWORD.CHANGE_PASSWORD.FAILURE,
        err: err.message,
      });
    }
  };
